import { useEffect, useState } from 'react';

import { useDocumentTitle } from 'hooks/document-title';
import { useParams } from 'react-router-dom';

import { FormThanksCard } from 'components/FormThanksCard/FormThanksCard';
import { Loading } from 'components/Loading/Loading';

import { useGetRefereeBrandByTokenQuery } from 'api/referees-api';

import styles from './RefereeCompletion.module.scss';

export const RefereeCompletion = () => {
  useDocumentTitle('Checkmate - Reference Checking and Background Screening Software');

  const { token } = useParams();

  const { data: brand, isLoading: loadingBrand } = useGetRefereeBrandByTokenQuery(token);
  const [thanksState, setThanksState] = useState(false);

  const url = 'https://www.checkmate.tech/app/submission-confirmation';

  useEffect(() => {
    setThanksState(true);
    setTimeout(() => window.location.replace(url), thanksState ? 5000 : 3000);
  }, [brand]);

  return (
    <div className={styles.root}>
      <Loading active={loadingBrand} />
      <div className={`${styles.content} u-max-width-content`}>
        {thanksState ? (
          <FormThanksCard />
        ) : (
          <img
            className={styles.accountLogo}
            src={brand?.brand_logo ? brand?.brand_logo : 'assets/images/checkmate/icon-label.svg'}
            alt="logo"
          />
        )}
      </div>
    </div>
  );
};

export default RefereeCompletion;
